import { useRef, useState } from "react";
import { toast } from "sonner";
import api, { API } from "@/lib/api";
import { Upload, Loader2, Link as LinkIcon } from "lucide-react";

export default function ImageUploader({ value, onChange, testid = "image" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/uploads", fd);
      onChange(`${API}/uploads/file/${data.id}`);
      toast.success("Immagine caricata");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nel caricamento");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="mt-2 space-y-2">
      <div className="flex items-center gap-2 border border-zinc-700 bg-zinc-950 px-3">
        <LinkIcon className="h-4 w-4 text-zinc-500" />
        <input
          data-testid={`${testid}-url`}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="URL immagine oppure carica un file"
          className="w-full bg-transparent py-2.5 text-zinc-100 text-sm outline-none placeholder:text-zinc-600"
        />
      </div>
      <input ref={fileRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid={`${testid}-file`} />
      <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid={`${testid}-upload-btn`}
        className="inline-flex items-center gap-2 border border-zinc-700 text-zinc-300 text-xs font-bold tracking-[0.15em] uppercase px-4 py-2.5 hover:border-yellow-400 hover:text-yellow-400 transition-colors duration-200 disabled:opacity-50">
        {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {uploading ? "Caricamento…" : "Carica foto copertina"}
      </button>
      {value && <img src={value} alt="preview" className="h-32 w-full object-cover border border-zinc-800" />}
    </div>
  );
}
